<template>
  
    <el-container>
     
      <el-main>
       <h1>Common operations</h1>
        <h3>Drag image from desktop</h3>
         <div>
          <img src="../assets/markmind/image.gif" alt="" width="800">
       </div>
 
        <h3>Copy text from browser</h3>
         <div>
          <img src="../assets/markmind/text.gif" alt="" width="800">
       </div>

        <h3>Drag nodes</h3>
         <div>
          <img src="../assets/markmind/nodes.gif" alt="" width="800">
       </div>
      
      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'shortcutPage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
